import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollar } from "@fortawesome/free-solid-svg-icons";
import { Col, FormControl, FormGroup, FormLabel, InputGroup, Row } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";

interface props {
  data: any;
  setData: any;
}

const TotalPedido: React.FC<props> = ({ data, setData }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { id, value } = event.target;
    setData((prevForm: any) => ({
      ...prevForm,
      [id]: value,
    }));
  };

  return (
    <>
      <Row>
        <Col className="d-flex align-items-center gap-2 justify-content-start">
          <FontAwesomeIcon icon={faDollar} className="fa-xl mb-1" />
          <h4>Total do Pedido</h4>
        </Col>
      </Row>

      <Col className="col-lg-2 col-md-4 col-12 mt-2">
        <FormGroup>
          <FormLabel>Desconto</FormLabel>
          <InputGroup>
            <InputGroupText className="bg-secondary text-white">R$</InputGroupText>
            <FormControl
              type="text"
              id="valor_desconto"
              value={data.valor_desconto}
              placeholder="0,00"
              onChange={handleChange}
            />
          </InputGroup>
        </FormGroup>
      </Col>

      <Col className="col-lg-2 col-md-4 col-12 mt-2">
        <FormGroup>
          <FormLabel>% de Desconto</FormLabel>
          <InputGroup>
            <FormControl
              type="text"
              id="porc_desconto"
              value={data.porc_desconto}
              placeholder="0,00"
              onChange={handleChange}
            />
            <InputGroupText  className="bg-secondary text-white">%</InputGroupText>
          </InputGroup>
        </FormGroup>
      </Col>

      <Col className="col-lg-2 col-md-4 col-12 mt-2">
        <FormGroup>
          <FormLabel>Nº Peças</FormLabel>
          <FormControl
            type="text"
            id="num_peca"
            disabled
            value={data.num_peca}
            placeholder="0,00"
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      <Col className="col-lg-3 col-md-6 col-12 mt-2">
        <FormGroup>
          <FormLabel>Total Bruto</FormLabel>
          <InputGroup>
          <InputGroupText  className="bg-secondary text-white">R$</InputGroupText>
          <FormControl
            type="text"
            id="total_bruto"
            value={data.total_bruto}
            placeholder="0,00"
            onChange={handleChange}
          />
          </InputGroup>
        </FormGroup>
      </Col>

      <Col className="col-lg-3 col-md-6 col-12 mt-2">
        <FormGroup>
          <FormLabel>Total Pedido</FormLabel>
          <InputGroup>
          <InputGroupText  className="bg-secondary text-white">R$</InputGroupText>
          <FormControl
            type="text"
            id="total"
            value={data.total}
            placeholder="0,00"
            onChange={handleChange}
          />
          </InputGroup>
        </FormGroup>
      </Col>
    </>
  );
};

export default TotalPedido;
